/**
 * Выравнивание блоков "Новое на сайте" по высоте
 */

const newOnSiteEqualHeight = (breakpoint_mobile) => {
    if ($(document).width() < breakpoint_mobile) {
        $(document).trigger('hh:homepage:new_on_site_flatted', []);

        return;
    }

    var new_on_site__block = $('.hh-new-on-site__col-item .hh-media-posts-small');

    var blocks_in_row = 2; // сколько блоков в одной строке
    var current_block = 1;
    var current_block_row = [];

    new_on_site__block.each(function (index, element) {
        current_block_row.push(element);
        current_block++;

        if (current_block > blocks_in_row) {
            equalizeRowHeights(current_block_row);

            current_block = 1;
            current_block_row = [];
        }
    });

    // Считаем высоту блока
    const new_on_site_block__col_item = $('.hh-new-on-site__col-item');
    const new_on_site_block__col_item__margin = parseInt(new_on_site_block__col_item.css('margin-bottom'));
    const new_on_site_block__row = $('.hh-new-on-site__row');
    const new_on_site_block__height = new_on_site_block__row.outerHeight() - new_on_site_block__col_item__margin;

    $(document).trigger('hh:homepage:new_on_site_flatted', [new_on_site_block__height]); // Выравнивание завершено
};

const equalizeRowHeights = (row) => {
    var heights = row.map(function (element) {
        return $(element).height();
    });
    var maxHeight = Math.max.apply(null, heights);

    row.forEach(function (element, index) {
        if (heights[index] < maxHeight) {
            $(element).height(maxHeight);
        }
    });
};

export default newOnSiteEqualHeight;
